import styled from 'styled-components/macro';
import Span from '../../elements/span';
import colors from '../../../styles/themes/colors';
import modularScale from '../../../styles/helpers/modular-scale';
import { compose, space } from 'styled-system';

export default styled(Span)`
  background: ${colors.Blue};
  color: ${colors.White};
  padding: 0.25em 1em;
  border-radius: 1em;
  font-size: ${modularScale(-2)};
  text-transform: uppercase;

  ${compose(space)}
`;
